import { useId } from "react";
import { CloseButton } from "@/components/base/buttons/close-button";
import { DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { cx } from "@/utils/cx";

const TEMPLATE_CATEGORY_SUGGESTIONS = ["Outreach", "Follow-up", "Samples", "Collaborations", "Support"];
export const DEFAULT_TEMPLATE_CATEGORY = "Uncategorised";

export function TemplateDialogHeader({ title, onClose }: { title: string; onClose: () => void }) {
  return (
    <div className="flex items-start justify-between gap-4">
      <DialogTitle className="text-xl leading-7 font-semibold tracking-normal text-primary">{title}</DialogTitle>
      <CloseButton onPress={onClose} className="-mt-1.5 -mr-1.5 shrink-0" />
    </div>
  );
}

type TemplateDetailsFieldsProps = {
  name: string;
  onNameChange: (name: string) => void;
  category: string;
  onCategoryChange: (category: string) => void;
  categories: string[];
  nameLabel: string;
  labelClassName: string;
  fieldClassName?: string;
  autoFocusName?: boolean;
};

export function TemplateDetailsFields({
  name,
  onNameChange,
  category,
  onCategoryChange,
  categories,
  nameLabel,
  labelClassName,
  fieldClassName,
  autoFocusName,
}: TemplateDetailsFieldsProps) {
  const id = useId();
  const suggestions = Array.from(new Set([...TEMPLATE_CATEGORY_SUGGESTIONS, ...categories]));

  return (
    <>
      <div className={cx("flex flex-col gap-1.5", fieldClassName)}>
        <label htmlFor={`${id}-name`} className={labelClassName}>
          {nameLabel}
        </label>
        <Input
          id={`${id}-name`}
          autoFocus={autoFocusName}
          value={name}
          maxLength={255}
          onChange={(e) => onNameChange(e.target.value)}
          placeholder="e.g. Takedown request"
        />
      </div>
      <div className={cx("flex flex-col gap-1.5", fieldClassName)}>
        <label htmlFor={`${id}-category`} className={labelClassName}>
          Category
        </label>
        <Input
          id={`${id}-category`}
          list={`${id}-categories`}
          value={category}
          maxLength={255}
          onChange={(e) => onCategoryChange(e.target.value)}
          placeholder="Select or type a category"
        />
        <datalist id={`${id}-categories`}>
          {suggestions.map((suggestion) => (
            <option key={suggestion} value={suggestion} />
          ))}
        </datalist>
      </div>
    </>
  );
}
